import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogEmployeeVsContractor() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Employee vs. Contractor: The Math Behind Outsourcing Layout & Detailing in 2026 | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Discover why Vancouver construction firms are converting fixed employee costs into variable project expenses by outsourcing AutoCAD layout and detailing work in 2026.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'construction outsourcing Vancouver, layout detailing costs, AutoCAD contractor, construction overhead reduction, BC construction staffing');
    }

    // Add Schema.org JSON-LD for Article
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Employee vs. Contractor: The Math Behind Outsourcing Your Layout & Detailing in 2026',
      description: 'Discover why Vancouver construction firms are converting fixed employee costs into variable project expenses by outsourcing AutoCAD layout and detailing work in 2026.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2026-01-15',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-employee-vs-contractor"]')) {
      script.setAttribute('data-schema', 'blog-employee-vs-contractor');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-employee-vs-contractor"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
